import { Component } from "react";
import DataResult from "../data/bean/data_result";
import Config from "../Config";
import ListingWebServices from "../service/listing_web_services";
import ProposalServices from "../service/proposal_web_services";
import UtilBloc from "./util_bloc";
import Labels from "../ui/constant/labels";
import DeclarationFormSection from "../data/bean/declaration_form_section_bean";
import LanguageBloc from "./language_bloc";

class ProposalBloc extends Component {
   
   //Get role when user loggin successfully
    static getNoBeneficiary() {
      let noBeneficiary = sessionStorage.getItem("noBeneficiary");
      return noBeneficiary || false;
    }

    //Save sign status when user loggin successfully in Customer Flow
    static saveNoBeneficiary(value) {
      sessionStorage.setItem("noBeneficiary", value == true || value == "true" || value == "TRUE" ? true : false);
    }
  
   static isWithinOneYear(dateString) {
    // Parse the input date string into a Date object     
    const parts = dateString?.split('-');
    const inputDate = new Date(parts[0], parts[1] - 1, parts[2]);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in milliseconds between the dates
    const difference_ms = currentDate - inputDate;

    // Convert milliseconds to years
    const difference_years = difference_ms / (1000 * 60 * 60 * 24 * 365);

    // Check if the difference is less than or equal to 1 year
    return difference_years <= 1;
}
  //hadSignedSignature depend on status
  static hadSignedSignature(status) {
    let signed = false;
    if (status == "PENDING_DC_SP" ||
      status == "PENDING_DC_CAC" ||
      status == "REJECTED_SP" ||
      status == "REJECTED_CAC" ||
      status == "APPROVED" ||
      status == "SUBMITTED" ||
      status == "PENDING_ACTION_AP"
    ) {
      signed = true
    }
    return signed;

  }

  //Get name of status from status code
  static getProposalStatusByStatusCode(code) {
    if (code == "PENDING_SUBMISSION") {
      return "Pending Submission";
    }

    if (code == "PENDING_REVIEW") {
      return "Pending Review";
    }

  }

  
  //updateOtpMode
  static async updateOtpMode(proposalId,notificationType, clientType) {
    let resp = await ProposalServices.updateOtpMode(proposalId,notificationType, clientType);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //checkCustExistProposal
  static async importProposalPersonalData(payload, validateToImport) {
    let resp = await ProposalServices.importProposalPersonalData(payload, validateToImport || false);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //checkCustExistProposal
  static async importProposalPersonalData(payload, validateToImport) {
    let resp = await ProposalServices.importProposalPersonalData(payload, validateToImport || false);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }


  //deleteProposalById
  static async deleteProposalById(proposalId, quotationId) {
    let resp = await ProposalServices.deleteProposalById(proposalId, quotationId);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //viewProposalById
  static async viewProposalById(payload, role) {
    let resp = await ProposalServices.viewProposalById(payload, role);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //Release proposal in CAC and Supervisor Flow with proposal id
  static async cancelProposalById(payload, role) {
    let resp = await ProposalServices.cancelProposalById(payload, role);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getDeclarationQuestions in Proposal Step
  static async getDeclarationQuestions(payload) {
    let resp = await ProposalServices.getDeclarationQuestions(payload);
    if (resp.success) {
      let declarationFormSections = [];
      declarationFormSections = this.convertToSectionAndQuestion(resp.data);
      return new DataResult(true, resp.message, declarationFormSections);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getHealthDeclarationQuestions
  static async getHealthDeclarationQuestions(productCode) {
    let resp = await ProposalServices.getHealthDeclarationForm(productCode);
    if (resp.success) {
      let declarationFormSections = [];
      declarationFormSections = this.convertToSectionAndQuestion(resp.data);
      return new DataResult(true, resp.message, declarationFormSections);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getCustomerAcknowledgeDeclarationQuestions
  static async getCustomerAcknowledgeDeclarationQuestions() {
    let resp = await ProposalServices.getCustomerAcknowledgeDeclarationForm();
    if (resp.success) {
      let declarationFormSections = [];
      declarationFormSections = this.convertToSectionAndQuestion(resp.data);
      return new DataResult(true, resp.message, declarationFormSections);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //convertToSectionAndQuestion to beans 
  static convertToSectionAndQuestion(result) {
    let declarationFormSections = [];
    let section;
    result.map((data, index) => {
      section = new DeclarationFormSection(index + 1, "", "", []);
      data.form.properties.questions.map((item, pos) => {
        section.questions.push({
          seq: pos + 1,
          questionNo: item.questionNo,
          questionText: item.question.en,
          questionTextBM: item.question.bm,
          selection: null,
          enabled: pos === 0,
          redAlertText: item.errorMessage,
          popUpErrorCode: "",
          canSelect: true,
          hasDialogPopup: false,
          category: "HQ",
          spanList: [],
          code: "",
          compulsoryYes: true,
          questionType: "YESNO",
          freeText: "",
          checkboxes: null,
          answerProperties: item.answerProperties,
        });
      });
      declarationFormSections.push(section);
    });
    return declarationFormSections;
  }

  //createNewProposal
  static async createNewProposal(id, isImportData) {
    let payload = {
      quotationId: id,
    };
    let resp = await ProposalServices.newProposal(payload, isImportData);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //submitProposal to IL in CAC and Supervisor Flow
  static async submitProposal(proposalId) {
    let resp = await ProposalServices.submitProposal(proposalId);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async saveAuthorizedPerson(proposalId,payload) {
    let resp = await ProposalServices.saveAuthorizedPerson(proposalId,payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getAuthorizedPerson(proposalId) {
    let resp = await ProposalServices.getAuthorizedPerson(proposalId);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async saveNominationBeneficiary(proposalId,payload) {
    let resp = await ProposalServices.saveNominationBeneficiary(proposalId,payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getNominationBeneficiary(proposalId) {
    let resp = await ProposalServices.getNominationBeneficiary(proposalId);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  

  static async getCompanyDetails(proposalId) {
    let resp = await ProposalServices.getCompanyDetails(proposalId);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }


  

  static async saveCompanyDetails(proposalId,payload) {
    let resp = await ProposalServices.saveCompanyDetails(proposalId,payload);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  

  static mapProposalForm(response, category) {
    let record = null;
    if (response.attributes?.data.length > 0) {
      record = response.attributes?.data.filter(
        (item) => item.proposal_attr?.category == category
      );
    }
    if (record) {
      return record[0]?.proposal_attr?.properties;
    } else {
      return null;
    }
  }

  //saveFormProposal value for each step of proposal with proposal id and category
  static async saveFormProposal(id, category, payload, extraData) {
    //Add hadrcoded payload for BE needs
    if (category == Config.formProposalDetailMappingCode.personalDetails) {
      //Pass Client id
      payload.clientId = extraData;
    }

    if (
      category == Config.formProposalDetailMappingCode.salesRepresentativeDetail
    ) {
      payload.contactDetails = extraData;
    }

    let resp = await ProposalServices.saveFormProposal(id, category, payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getFormDetailProposal with id proposal
  static async getFormDetailProposal(id, payload) {
    let result = {};
    let response = await ProposalServices.getProposalDetail(id, payload);
    if (response.success) {
      switch (payload["category"]) {
        case Config.formProposalDetailMapping[0].category:
          result = this.mapProposalForm(response);
          break;
        case Config.formProposalDetailMapping[1].category:
          result = this.mapProposalForm(response);
          break;
        case Config.formProposalDetailMapping[2].category:
          result = this.mapProposalForm(response);
          break;
        case Config.formProposalDetailMapping[3].category:
          result = this.mapProposalForm(response);
          break;
        case Config.formProposalDetailMapping[4].category:
          result = this.mapProposalForm(response);
          break;
        case "TAKAFUL_DETAILS":
          result = this.mapQuotationTakafulDetailForm(response);
          break;
        default:
          break;
      }
    }
    return result;
  }

  //getProposalDetail
  static async getProposalDetail(id) {
    let payload = {
      id: id,
    };
    let result = {};

    let response = await ProposalServices.getProposalDetail(payload);

    if (response.success) {
      result = response.data;
    }
    return result;
  }

  //getProposalDetailView for CAC and Supervisor Flow
  static async getProposalDetailView(id, userType, userId,purposeOfProposal) {
    let payload = {
      id: id,
    };
    let result = {};

    let response = await ProposalServices.getProposalDetail(payload, userType, userId);    
    if (response.success) {
      result = this.mapProposalDetail(response.data,purposeOfProposal);
    }
    return result;
  }

  //getProposalDetailView for CAC and Supervisor Flow
  static async getProposalDetailSupervisorView(id, userId) {
    let payload = {
      id: id,
    };
    let result = {};

    let response = await ProposalServices.getProposalSupervisorDetail(payload, userId);
    //console.log("RESPOMD", response)
    if (response.success) {
      result = this.mapProposalDetail(response.data);
      
      //console.log("check result proposal",result)
    }
    return result;
  }
  static getCompanyDetailsData(companyDetailsData,company){
    //console.log("companyRepresentativeData",companyDetailsData)    
    return  companyDetailsData ? {
      registeredNameCompany:{
        caption: Labels.LBL_REGISTERED_NAME_COMPANY,
        value:companyDetailsData.registeredNameCompany || company
      },
      newCompanyRegistrationNo: {
        caption: Labels.LBL_NEW_COMPANY_REGISTRATION_NO,
        value:
        companyDetailsData.newCompanyRegistrationNo,
      },
      companyCountry:companyDetailsData.companyCountry ? {
        caption: Labels.LBL_COMPANY_COUNTRY,
        value:companyDetailsData.companyCountry?.description
      }:null,
      invoicing:{
        caption: "invoicingCD",
        value:true
      },
      companyAddressLine1: {
        caption: Labels.LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_1,
        value:
        companyDetailsData.companyAddress?.line1,
      },
      companyAddressLine2: {
        caption: Labels.LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_2,
        value:
        companyDetailsData.companyAddress?.line2 || "-",
      },
      companyAddressLine3: {
        caption: Labels.LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_3,
        value:
        companyDetailsData.companyAddress?.line3 || "-",
      },
      companyAddressPostCode: {
        caption: Labels.LBL_POSTCODE,
        value:companyDetailsData.companyAddress.postCode,
      },
      companyAddressCity: {
        caption: Labels.LBL_CITY,
        value:
        companyDetailsData.companyAddress.city.cityName,
      },
      companyAddressState: {
        caption: Labels.LBL_STATE,
        value:
        companyDetailsData.companyAddress.state.stateName,
      },
      companyAddressCountry: {
        caption: Labels.LBL_COUNTRY,
        value:
        companyDetailsData.companyAddress.country.description,
      },
      countryCodeMobile: {
        caption: Labels.COUNTRYCODE,
        value:companyDetailsData.countryCodeMobile?.code ? companyDetailsData.countryCodeMobile?.description:"-"
      },
      companyTel: {
        caption: Labels.BUSINESSTELNO,
        value: companyDetailsData?.companyTel,
      },
      companyEmail: {
        caption: Labels.LBL_EMAIL,
        value: companyDetailsData?.companyEmail,
      },
      insuranceCertificateDelivery:{
        caption: Labels.LBL_INSURANCE_CERTIFICATE_DELIVERY,
        value:
        companyDetailsData.insuranceCertificateDelivery?.description,
      },

      


      
      /* refundOfPremiumRider: mortgageDetailsAttr.quotation_attr.properties.mortgageCover.refundOfPremiumRider?.code=="7RP3" ? {
        caption: Labels.LBL_REFUND_PREMIUM_RIDER,
        value:premium.ropPremium,
        prefix: premium.ropPremium!=0.0 ? "RM ":"",              
      } :null,
      singlePremiumToBeAssured :{
        caption: Labels.LBL_SINGLE_PREMIUM_TO_BE_ASSURED,
        value:premium.basicPremium,
        prefix: premium.basicPremium!=0.0 ? "RM " :"",              
      }   */
    } : {}
  }

  
  static getNominationBeneficiaryData(nominationBeneficiaryData){
    //console.log("nominationBeneficiaryData",nominationBeneficiaryData)    
    return  nominationBeneficiaryData ? {
      declareAnyBeneficiary:{
        caption: Labels.LBL_ANY_BENEFICIARY,
        value:nominationBeneficiaryData.declareAnyBeneficiary.label
      },
      anyChild:nominationBeneficiaryData?.declareAnyBeneficiary.label=="Yes" ? {
        caption: Labels.LBL_ANY_CHILD,
        value:nominationBeneficiaryData.anyChild.label
      }:null,
    } : {}
  }
  
  static getCompanyRepresentativeData(companyRepresentativeData){
    console.log("companyRepresentativeData",companyRepresentativeData)
    return  companyRepresentativeData ? {
      isSameAsInsuredMember:{
        caption: "Authorized Company Representative same as Proposed Insured Member?",
        value:
        companyRepresentativeData.isSameAsInsuredMember?.label || "No",
      },
      name:{
        caption: Labels.LBL_NAME,
        value:companyRepresentativeData.name
      },
      typeId: {
        caption: Labels.LBL_ID_TYPE,
        value:
        companyRepresentativeData.typeId.description,
      },
      idNo:companyRepresentativeData.idNo ? {
        caption: "ID Number",
        value:companyRepresentativeData.idNo
      }:null,
      designation: {
        caption: "Designation",
        value:companyRepresentativeData.designation ,
      },
      countryCodeMobile: {
        caption: Labels.COUNTRYCODE,
        value:companyRepresentativeData?.countryCodeMobile?.code?
        companyRepresentativeData.countryCodeMobile.description:"-",
        code:companyRepresentativeData?.countryCodeMobile?.code ? companyRepresentativeData?.countryCodeMobile?.code:"-",
      },
      mobileNumber: {
        caption: Labels.LBL_MOBILE_PHONE,
        value: companyRepresentativeData?.mobileNumber,
      },      
      email: {
        caption: Labels.LBL_EMAIL,
        value: companyRepresentativeData?.email,
      },
      isSameAsInsuredMemberEmail:companyRepresentativeData.isSameAsInsuredMember?.label=="No" ? {
        caption: "Email Address same as Proposed Insured Member?",
        value: companyRepresentativeData.isSameAsInsuredMemberEmail?.label || "-"
        ,
      }:null,

      
      /* refundOfPremiumRider: mortgageDetailsAttr.quotation_attr.properties.mortgageCover.refundOfPremiumRider?.code=="7RP3" ? {
        caption: Labels.LBL_REFUND_PREMIUM_RIDER,
        value:premium.ropPremium,
        prefix: premium.ropPremium!=0.0 ? "RM ":"",              
      } :null,
      singlePremiumToBeAssured :{
        caption: Labels.LBL_SINGLE_PREMIUM_TO_BE_ASSURED,
        value:premium.basicPremium,
        prefix: premium.basicPremium!=0.0 ? "RM " :"",              
      }   */
    } : {}
  }

  static getMortgageDetailReview(mortgageDetailsData,productSelectionCode){
    //console.log("mortgageDetailsData",mortgageDetailsData)
    return  mortgageDetailsData ? {
      purposeOfProposal:{
        caption: Labels.LBL_PURPOSE_OF_PROPOSAL,
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsData.purposeOfProposal
            .description,
          mortgageDetailsData.purposeOfProposal
            .description
        ),
      },
      planName: {
        caption: Labels.LBL_PRODUCT_NAME,
        value:
        mortgageDetailsData.planName.description,
      },
      insuranceType:mortgageDetailsData.insuranceType ? {
        caption: Labels.LBL_INSURANCE_TYPE,
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsData.insuranceType
            .description,
          mortgageDetailsData.insuranceType
            .description
        ),
      }:null,
      arrangement: {
        caption: Labels.LBL_ARRANGEMENT,
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsData.arrangement.label,
          mortgageDetailsData.arrangement.label
        ),
      },
      paymentMode: {
        caption: Labels.LBL_PAYMENT_MODE,
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsData?.paymentMode?.label || "-",
          mortgageDetailsData?.paymentMode?.label || "-"
        ),
      },
      loanAccountNo: {
        caption: Labels.LBL_LOAN_ACCOUNT_NO,
        value:
        mortgageDetailsData.loanAccountNo || "-",
      },
      basicPremium: {
        caption: Labels.LBL_BASIC_AMOUNT,
        value: mortgageDetailsData.basicAmount,
        prefix:
        mortgageDetailsData.basicAmount != 0.0
            ? "RM "
            : null,
        /* suffix:
          mortgageDetailsAttr.proposal_attr.properties?.basicPremium != 0.0
            ? ".00"
            : "", */
      },
      ropPremium: {
        caption: Labels.LBL_ROP_AMOUNT,
        value: mortgageDetailsData.ropAmount,
        prefix:
        mortgageDetailsData.ropAmount != 0.0
            ? "RM "
            : null,
        /* suffix:
          mortgageDetailsAttr.proposal_attr.properties?.ropPremium != 0.0
            ? ".00"
            : "", */
      },
      totalAmount: {
        caption: Labels.LBL_TOTAL_AMOUNT,
        value:
        mortgageDetailsData.totalAmount,
        prefix:
        mortgageDetailsData.totalAmount != 0.0
            ? "RM "
            : null,
        /* suffix:
          mortgageDetailsAttr.proposal_attr.properties
            ?.totalPayableAmount != 0.0
            ? ".00"
            : "", */
      },

      
      loanAmount: {
        caption: Labels.LBL_LOAN_AMOUNT,
        value:
        mortgageDetailsData.loanAmount,
        prefix: "RM ",
        /* suffix: ".00", */
      },
      /* loanTenure: {
        caption: Labels.LBL_LOAN_TENURE,
        value:
          mortgageDetailsAttr.proposal_attr.properties.mortgageCover
            .loanTenure,
        type: "number",
        suffix:
          parseInt(
            mortgageDetailsAttr.proposal_attr.properties.mortgageCover
              .loanTenure
          ) > 1
            ? " years"
            : " year",
      },
      constructionPeriod: {
        caption: Labels.LBL_CONSTRUCTION_PERIOD,
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsAttr.proposal_attr.properties.mortgageCover
            .constructionPeriod.description,
          mortgageDetailsAttr.proposal_attr.properties.mortgageCover
            .constructionPeriod.description1
        ),
      }, */
      constructionPeriod:mortgageDetailsData.constructionPeriod ? {
        caption: productSelectionCode=="ESG" ? "Deferment Term" :"Deferment Period",
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsData.constructionPeriod.description,
          mortgageDetailsData.constructionPeriod.description1,
        ),
      }:null,
      loanInterestRate: {
        caption: Labels.LBL_LOAN_INTEREST_RATE,
        value:
        mortgageDetailsData.loanInterestRate,
        type: "number",
        fixed: 3,
        suffix: "%",
      },
      sumAssured: {
        caption: Labels.LBL_SUM_ASSURED,
        value:
        mortgageDetailsData.sumAssured,
        prefix: "RM ",
        /* suffix: ".00", */
      },
      
      defermentTerm: {
        caption: Labels.LBL_DEFERMENT_TERM,
        value: UtilBloc.convertToLocaleObject(
          mortgageDetailsData.mortgageDetailsData?.defermentTerm.description || "",
          mortgageDetailsData.mortgageDetailsData?.defermentTerm.description || "",
        ),
      },
      termOfCoverage: mortgageDetailsData.termOfCoverage ?{
        caption: productSelectionCode!="ESG" ? Labels.LBL_TERM_OF_COVERAGE_DEFERMENT_TERM : Labels.LBL_TERM_COVERAGE,
        value:
        mortgageDetailsData.termOfCoverage?.code || mortgageDetailsData.termOfCoverage,
        type: "number",
        suffix:
          parseInt(
            mortgageDetailsData.termOfCoverage?.code || mortgageDetailsData.termOfCoverage
          ) > 1
            ? " years"
            : " year",
      }:null,
      /* refundOfPremiumRider: mortgageDetailsAttr.quotation_attr.properties.mortgageCover.refundOfPremiumRider?.code=="7RP3" ? {
        caption: Labels.LBL_REFUND_PREMIUM_RIDER,
        value:premium.ropPremium,
        prefix: premium.ropPremium!=0.0 ? "RM ":"",              
      } :null,
      singlePremiumToBeAssured :{
        caption: Labels.LBL_SINGLE_PREMIUM_TO_BE_ASSURED,
        value:premium.basicPremium,
        prefix: premium.basicPremium!=0.0 ? "RM " :"",              
      }   */
    } : {}
  }

  static getPrefix(mobileNo){
    let prefix="+60";
    if(mobileNo && mobileNo.charAt(0)!="0"){      
      prefix="+60";
    }

    if(mobileNo && mobileNo.charAt(0)=="6" && mobileNo.charAt(1)=="0"){      
      prefix="+";        
    }

    if(mobileNo && mobileNo.charAt(0)=="0"){      
      prefix="+6";        
    }
    return prefix;
  }

  //mapProposalDetail for each step of proposal
  static mapProposalDetail(response,purposeOfProposal) {
    let generatedDocument = [];
    
    let indexOfMortgageDetails = 0;
    let proposal = response.proposal.data[0].proposal;  
    let quotation = response.quotation.data[0].quotation;    
    let productCode= proposal?.productCode || "";    
    let arrangmentCode= quotation?.arrangement || "";    
    indexOfMortgageDetails = response.attributes.data.findIndex(
      (item) => item.proposal_attr.category === "MORTGAGE_DETAILS"
    );    
    let indexOfSalesRepresentativeDetails = 0
    indexOfSalesRepresentativeDetails =
      response.attributes.data.findIndex(
        (item) =>
          item.proposal_attr.category ===
          Config.formProposalDetailMappingCode.salesRepresentativeDetail
      );
    let indexOfPersonalDetails = 0
    
    indexOfPersonalDetails = response.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMappingCode.personalDetails
    );

    let indexOfCompanyDetails = 0

    indexOfCompanyDetails = response.attributes.data.findIndex(
      (item) =>
        item.proposal_attr.category ===
        Config.formProposalDetailMappingCode.companyDetails
    );
  
    //console.log("COMEHEREOKK5")

    let mortgageDetailsAttr = response.attributes.data[indexOfMortgageDetails];

    let salesRepresentativeDetailsAttr = response.attributes.data[indexOfSalesRepresentativeDetails];

    let personalDetailsAttr = response.attributes.data[indexOfPersonalDetails];

    let companyDetailsAttr = response.attributes.data[indexOfCompanyDetails];
    //console.log("personalDetailsAttr", personalDetailsAttr)
    let data = null;

    if (response.attributes.data.length > 0) {
      let document = response.document.data || [];
      let amendment_form_SP = false
      if (document.length > 0) {
        document.map((item) => {
          if (item.uploaded_proposal_document && item.uploaded_proposal_document.documentCode == "amendment_form_SP") {
            amendment_form_SP = true
          }
        })
      }
      data = {
        status: response.proposal.data[0].proposal.trxStatus,
        proposal: response.proposal.data[0].proposal,
        refNo: response.proposal.data[0].proposal.proposalNo || response.proposal.data[0].proposal.refNo,
        amendment_form_SP: amendment_form_SP,
        quotationId: response.proposal.data[0].proposal.quotationId,
        mortgageDetails:{},
        salesRepresentativeDetails: salesRepresentativeDetailsAttr && salesRepresentativeDetailsAttr.proposal_attr.properties ? {
          salesRepresentativeName: {
            caption: Labels.LBL_SALES_REPRESENTATIVE_NAME,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .salesRepresentativeName,
          },
          salesRepresentativeMobileNumber: {
            caption: Labels.LBL_SALES_REPRESENTATIVE_MOBILE_NUMBER,
            value:salesRepresentativeDetailsAttr.proposal_attr.properties
            .salesRepresentativeMobileNumber ? this.getPrefix(salesRepresentativeDetailsAttr.proposal_attr.properties
              .salesRepresentativeMobileNumber)+
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .salesRepresentativeMobileNumber:'',
          },
          salesRepresentativeEmail: {
            caption: Labels.LBL_SALES_REPRESENTATIVE_EMAIL,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .salesRepresentativeEmail,
          },
          branchCode: {
            caption: Labels.LBL_BRANCH_CODE,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .branchCode,
          },
          branchCode: {
            caption: Labels.LBL_BRANCH_CODE,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .branchCode,
          },
          salesRepresentativeID: {
            caption: Labels.LBL_SALES_REPRESENTATIVE_ID,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .salesRepresentativeStaffID,
          },
          salesRepresentativeAgentCode: {
            caption: Labels.LBL_SALES_REPRESENTATIVE_CODE,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .salesRepresentativeAgentCode,
          },
          referralCode: {
            caption:salesRepresentativeDetailsAttr.proposal_attr.properties
            .referralBranchCode ? "Referral ID" : Labels.LBL_REFERRAL_CODE,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .referralCode,
          },
          referralBranchCode:{
            caption: "Referral ID Branch Code",
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .referralBranchCode?.description,
          },
          underB40Group:{
            caption: Labels.LBL_UNDER_B40_GROUP,
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .underB40Group?.label || "No",
          },
          campaignCode: {
            caption: "Bank Campaign Code",
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties
                .campaignCode,
          },
          useSectorCode:salesRepresentativeDetailsAttr.proposal_attr.properties.useSectorCode ?{
            caption: "Any sector code?",
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties.useSectorCode?.label,
          }:null,
          sectorCode:salesRepresentativeDetailsAttr.proposal_attr.properties.sectorCode? {
            caption: "Sector Code",
            value:
              salesRepresentativeDetailsAttr.proposal_attr.properties.sectorCode,
          }:null,
        } : {},
        personalDetails: personalDetailsAttr && personalDetailsAttr.proposal_attr.properties ? {
          purposeOfProposal:purposeOfProposal || "-",
          title: {
            caption: Labels.LBL_TITLE,
            value: personalDetailsAttr.proposal_attr.properties?.title?.description,
          },
          name: {
            caption: Labels.LBL_NAME,
            value: personalDetailsAttr.proposal_attr.properties?.name,
          },
          gender: {
            caption: Labels.LBL_GENDER,
            value:
              personalDetailsAttr.proposal_attr.properties?.gender?.description,
          },
          idNo: {
            caption: Labels.LBL_ID_NUMBER,
            value: personalDetailsAttr.proposal_attr.properties?.idNo,
          },
          typeId: {
            caption: Labels.LBL_ID_TYPE,
            value: personalDetailsAttr.proposal_attr.properties?.typeId?.description,
          },
          dob: {
            caption: Labels.LBL_DOB,
            value: personalDetailsAttr.proposal_attr.properties?.dob,
          },
          anb: {
            caption: Labels.LBL_AGE_ANB_INPUT,
            value: personalDetailsAttr.proposal_attr.properties?.anb,
          },
          maritalStatus: {
            caption: Labels.LBL_MARTIAL_STATUS,
            value:
              personalDetailsAttr.proposal_attr.properties?.maritalStatus
                ?.description,
          },
          muslim: {
            caption: Labels.LBL_ARE_YOU_MUSLIM,
            value: personalDetailsAttr.proposal_attr.properties?.muslim?.label,
          },
          race: {
            caption: Labels.LBL_RACE,
            value:
              personalDetailsAttr.proposal_attr.properties?.race?.description,
          },
          nationality: {
            caption: Labels.LBL_NATIONALITY,
            value:
              personalDetailsAttr.proposal_attr.properties?.nationality?.description,
          },
          countryOfBirth: {
            caption: Labels.LBL_COUNTRY_OF_BIRTH,
            value:
              personalDetailsAttr.proposal_attr.properties?.countryOfBirth
                ?.description,
          },
          height: personalDetailsAttr.proposal_attr.properties?.height
            ? {
              caption: Labels.LBL_HEIGHT,
              value: personalDetailsAttr.proposal_attr.properties?.height,
              suffix: " cm",
            }
            : "-",
          weight: personalDetailsAttr.proposal_attr.properties?.weight
            ? {
              caption: Labels.LBL_WEIGHT,
              value: personalDetailsAttr.proposal_attr.properties?.weight,
              suffix: " kg",
            }
            : "-",
          smoked: {
            caption: Labels.LBL_SMOKED_QUESTION,
            value: personalDetailsAttr.proposal_attr.properties?.smoked?.label,
          },
          typeCigarettes: {
            caption: Labels.LBL_TYPE_CIGARETTES,
            value: personalDetailsAttr.proposal_attr.properties?.typeCigarettes?.description ?? "-",
          },
          sticksPerDay: {
            caption: Labels.LBL_STICKS_PER_DAY,
            value: personalDetailsAttr.proposal_attr.properties?.sticksPerDay ?? "-",
          },
          yearsOfSmoked: {
            caption: Labels.LBL_YEARS_SMOKED,
            value: personalDetailsAttr.proposal_attr.properties?.yearsOfSmoked ?? "-",
          },
          occupation: {
            caption: Labels.LBL_OCCUPATION,
            value:
              personalDetailsAttr.proposal_attr.properties?.occupation
                ?.description,
          },
          occupationExactDuty: {
            caption: Labels.LBL_OCCUPATION_EXACT_DUTY,
            value:
              personalDetailsAttr.proposal_attr.properties?.occupationExactDuty,
          },
          nob: {
            caption: Labels.LBL_NOB,
            value:
              personalDetailsAttr.proposal_attr.properties?.nob?.description,
          },
          // fatca: {
          //   caption: Labels.LBL_FATCA,
          //   value: personalDetailsAttr.proposal_attr.properties?.fatca?.label,
          // },
          annualIncome: {
            caption: Labels.LBL_ANNUAL_INCOME,
            value: personalDetailsAttr.proposal_attr.properties?.annualIncome,
            prefix: "RM ",
            suffix: ".00",
          },
          invoicing: {
            caption: "invoicingPD",
            value:true,
          },
          relationship: null/* {
            caption: Labels.LBL_RELATIONSHIP,
            value: personalDetailsAttr.proposal_attr.properties?.relationship,
          } */,
          /* purposeOfProposal: {
            caption: Labels.LBL_PURPOSE_OF_PROPOSAL,
            value: personalDetailsAttr.proposal_attr.properties?.purposeOfProposal?.description,
          }, */
          countryCodeMobile: {
            caption: Labels.COUNTRYCODE,
            value:
              personalDetailsAttr.proposal_attr.properties?.countryCodeMobile
                ?.description,
            code: personalDetailsAttr.proposal_attr.properties
              ?.countryCodeMobile?.code,
          },
          mobileNumber: {
            caption: Labels.LBL_MOBILE_PHONE,
            value: personalDetailsAttr.proposal_attr.properties?.mobileNumber,
          },
          countryCodeResidenceTel: {
            caption: Labels.COUNTRYCODE,
            value:personalDetailsAttr.proposal_attr.properties
            ?.countryCodeResidenceTel?.code ?
              personalDetailsAttr.proposal_attr.properties
                ?.countryCodeResidenceTel?.description:"-",
          },
          residenceContact: {
            caption: Labels.RESIDENCETELNO,
            value:
              personalDetailsAttr.proposal_attr.properties?.residenceContact,
          },
          countryCodeBusinessTel: {
            caption: Labels.COUNTRYCODE,
            value:personalDetailsAttr.proposal_attr.properties
            ?.countryCodeBusinessTel?.code ?
              personalDetailsAttr.proposal_attr.properties
                ?.countryCodeBusinessTel?.description :"-",
          },
          businessContact: {
            caption: Labels.BUSINESSTELNO,
            value:
              personalDetailsAttr.proposal_attr.properties?.businessContact,
          },
          email: {
            caption: Labels.LBL_EMAIL,
            value: personalDetailsAttr.proposal_attr.properties?.email,
          },
          correspondenceAddressLine1: {
            caption: Labels.LBL_CORRESPONDENCE_ADDRESS_1,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.line1,
          },
          correspondenceAddressLine2: {
            caption: Labels.LBL_CORRESPONDENCE_ADDRESS_2,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.line2,
          },
          correspondenceAddressLine3: {
            caption: Labels.LBL_CORRESPONDENCE_ADDRESS_3,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.line3,
          },
          correspondenceAddressPostCode: {
            caption: Labels.LBL_POSTCODE,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.postCode ||
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.city?.postCode,
          },
          correspondenceAddressCityName: {
            caption: Labels.LBL_CITY,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.city?.cityName ||
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.city,
          },
          correspondenceAddressState: {
            caption: Labels.LBL_STATE,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.state?.stateName,
          },
          correspondenceAddressCountry: {
            caption: Labels.LBL_COUNTRY,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.correspondenceAddress?.country?.description,
          },
          residentAddressLine1: {
            caption: Labels.LBL_RESIDENT_ADDRESS_1,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.line1,
          },
          residentAddressLine2: {
            caption: Labels.LBL_RESIDENT_ADDRESS_2,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.line2,
          },
          residentAddressLine3: {
            caption: Labels.LBL_RESIDENT_ADDRESS_3,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.line3,
          },
          residentAddressPostCode: {
            caption: Labels.LBL_POSTCODE,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.postCode,
          },
          residentAddressCityName: {
            caption: Labels.LBL_CITY,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.city?.cityName || personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.city,
          },
          residentAddressState: {
            caption: Labels.LBL_STATE,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.state?.stateName || personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.state,
          },
          residentAddressCountry: {
            caption: Labels.LBL_COUNTRY,
            value:
              personalDetailsAttr.proposal_attr.properties?.residentAddress
                ?.country?.description,
          },          
          employerName: {
            caption: Labels.LBL_EMPLOYER_COMPANY_NAME,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerName
          },
          employerAddressLine1: {
            caption: Labels.LBL_EMPLOYER_ADDRESS_1,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.line1,
          },
          employerAddressLine2: {
            caption: Labels.LBL_EMPLOYER_ADDRESS_2,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.line2,
          },
          employerAddressLine3: {
            caption: Labels.LBL_EMPLOYER_ADDRESS_3,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.line3,
          },
          employerAddressPostCode: {
            caption: Labels.LBL_POSTCODE,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.postCode,
          },
          employerAddressCityName: {
            caption: Labels.LBL_CITY,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.city?.cityName || personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.city ,
          },
          employerAddressState: {
            caption: Labels.LBL_STATE,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.state?.stateName,
          },
          employerAddressCountry: {
            caption: Labels.LBL_COUNTRY,
            value:
              personalDetailsAttr.proposal_attr.properties?.employerAddress
                ?.country?.description,
          },
          insuranceCertificateDelivery:arrangmentCode=="3P" ? {
            caption: Labels.LBL_INSURANCE_CERTIFICATE_DELIVERY,
            value:
              personalDetailsAttr.proposal_attr.properties
                ?.insuranceCertificateDelivery?.description,
          }:null,
        } : {},
        companyDetails: companyDetailsAttr && companyDetailsAttr.proposal_attr.properties ? {
          registeredNameCompany: {
            caption: Labels.LBL_REGISTERED_NAME_COMPANY,
            value: companyDetailsAttr.proposal_attr.properties?.registeredNameCompany,
          },
          newCompanyRegistrationNo: {
            caption: Labels.LBL_NEW_COMPANY_REGISTRATION_NO,
            value: companyDetailsAttr.proposal_attr.properties?.newCompanyRegistrationNo,
          },
          oldCompanyRegistrationNo: {
            caption: Labels.LBL_OLD_COMPANY_REGISTRATION_NO,
            value: companyDetailsAttr.proposal_attr.properties?.oldCompanyRegistrationNo,
          },
          companyCountry : {
            caption: Labels.LBL_COMPANY_COUNTRY,
            value:
              companyDetailsAttr.proposal_attr.properties?.companyCountry
                ?.description,
            code: companyDetailsAttr.proposal_attr.properties
              ?.companyCountry?.code,
          },
          countryCodeMobile: {
            caption: Labels.COUNTRYCODE,
            value:
              companyDetailsAttr.proposal_attr.properties?.countryCodeMobile
                ?.description,
            code: companyDetailsAttr.proposal_attr.properties
              ?.countryCodeMobile?.code,
          },
          companyTel: {
            caption: Labels.LBL_MOBILE_PHONE,
            value: companyDetailsAttr.proposal_attr.properties?.companyTel,
          },
          companyAddressLine1: {
            caption: Labels.LBL_CORRESPONDENCE_ADDRESS_1,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.line1,
          },
          companyAddressLine2: {
            caption: Labels.LBL_CORRESPONDENCE_ADDRESS_2,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.line2,
          },
          companyAddressLine3: {
            caption: Labels.LBL_CORRESPONDENCE_ADDRESS_3,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.line3,
          },
          companyAddressPostCode: {
            caption: Labels.LBL_POSTCODE,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.postCode ||
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.city?.postCode,
          },
          companyAddressCityName: {
            caption: Labels.LBL_CITY,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.city?.cityName ||
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.city,
          },
          companyAddressState: {
            caption: Labels.LBL_STATE,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.state?.stateName,
          },
          companyAddressCountry: {
            caption: Labels.LBL_COUNTRY,
            value:
              companyDetailsAttr.proposal_attr.properties
                ?.companyAddress?.country?.description,
          },
          companyEmail: {
            caption: Labels.LBL_EMAIL,
            value: companyDetailsAttr.proposal_attr.properties?.companyEmail,
          }        
        } : {},
        companyDetailsOrigin:companyDetailsAttr && companyDetailsAttr.proposal_attr.properties ? companyDetailsAttr.proposal_attr.properties : {},
        personalDetailsOrigin:personalDetailsAttr && personalDetailsAttr.proposal_attr.properties ? personalDetailsAttr.proposal_attr.properties : {},
        generatedDocuments: {
          caption: Labels.LBL_GENERATED_DOCUMENTS,
          data: generatedDocument,
        },
        productCode:productCode,
        arrangmentCode:arrangmentCode
      };
    }
    console.log("DATAMORTGAGEDETAILS", data);
    return data;
  }

  //getMortgageDetail
  static async getMortgageDetail(id, category) {
    let result = {};

    let response = await ProposalServices.getMortgageDetail(id, category);

    if (response.success) {
      result = response.data;
    }
    return result;
  }

  //emailProposal
  static async emailProposal(payload, type,clientType) {
    let resp = await ProposalServices.emailProposal(payload, type,clientType);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //generateDocuments in Upload Documents Step
  static async generateDocuments(id) {
    let resp = await ProposalServices.generateDocuments(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //generateDocuments in Upload Documents Step
  static async generateEntityForm(id) {
    let resp = await ProposalServices.generateEntityForm(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getProposalDoc with id document
  static async getProposalDoc(id, userType, userId) {
    let resp = await ProposalServices.getProposalDoc(id, userType, userId);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getNominationBeneficiaryForm(id,/*  userType, userId */) {
    let resp = await ProposalServices.getNominationBeneficiaryForm(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getEntityForm(id,/*  userType, userId */) {
    let resp = await ProposalServices.getEntityForm(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getEMIDForm(id,/*  userType, userId */) {
    let resp = await ProposalServices.getEMIDForm(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }
  
  
  static async getNominationBeneficiaryFormGenerate(id,/*  userType, userId */) {
    let resp = await ProposalServices.getNominationBeneficiaryFormGenerate(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getEntityFormGenerate(id,/*  userType, userId */) {
    let resp = await ProposalServices.getEntityFormGenerate(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  static async getEMIDFormGenerate(id,/*  userType, userId */) {
    let resp = await ProposalServices.getEMIDFormGenerate(id);

    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //submitForReviewProposal for Agent Flow
  static async submitForReviewProposal(proposalId, status) {
    let resp = await ProposalServices.submitForReviewProposal(proposalId, status);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message,null,resp.code);
    }
  }

  //submitForReviewProposal for Customer Flow
  static async submitClientForReviewProposal(proposalId, status) {
    let resp = await ProposalServices.submitClientForReviewProposal(proposalId, status);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  ////submitForReviewSuperviorProposal for CAC and Supervisor Flow
  static async submitForReviewSuperviorProposal(proposalId, status, payload, userId) {
    let resp = await ProposalServices.submitForReviewSuperviorProposal(proposalId, status, payload, userId);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //submitProposalCAC
  static async submitProposalCAC(proposalId, userId) {
    let resp = await ProposalServices.submitProposalCAC(proposalId, userId);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }
}

export default ProposalBloc;
